import React from "react";
import AccountProvider from "./account";
import SettingsProvider from "./settings";
import CartProvider from "./cart";
import ProductFinderProvider from "./product-finder";

const GlobalProvider = ({ children }) => (
    <AccountProvider>
        <CartProvider>
            <SettingsProvider>
                <ProductFinderProvider>
                    {children}            
                </ProductFinderProvider>
            </SettingsProvider>
        </CartProvider>
    </AccountProvider>
);

export default GlobalProvider;
